<template>
  <div class="document-info">
    <p>
      <span>Created:</span>
      {{ doc.createdAt | dateFormat }}
      <span>Updated:</span>
      {{ doc.updatedAt | dateFormat }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    doc: Object,
  },
};
</script>

<style lang="scss" scoped="">
.document-info {
  span {
    font-weight: bold;
  }
}
</style>
